import { motion } from "framer-motion";
import { TrendingUp, Zap, Users, ShieldCheck } from "lucide-react";

const IMAGE = "https://images.pexels.com/photos/97080/pexels-photo-97080.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const RESULTS = [
  { icon: TrendingUp, k: "60%", l: "Redução típica de trabalho manual em rotinas fiscais e financeiras." },
  { icon: Zap, k: "4x", l: "Aceleração de projetos de automação com low-code + IA." },
  { icon: Users, k: "5", l: "ERPs operacionais gerenciados simultaneamente em nível LATAM." },
  { icon: ShieldCheck, k: "100%", l: "Compliance embutido nas entregas — auditoria pronta." },
];

export default function Results() {
  return (
    <section id="resultados" className="relative py-28 md:py-36" data-testid="results-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-6"
          >
            <p className="label-eyebrow">Resultados típicos</p>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl mt-4 leading-tight tracking-tight text-white">
              Números que <span className="gradient-text">o board</span> quer ver.
            </h2>
            <p className="mt-6 text-lg text-[#B8C0D0] leading-relaxed max-w-lg">
              Impactos reais observados em projetos de modernização e automação em manufatura, serviços e multinacionais — sempre com KPIs claros antes e depois.
            </p>

            <div className="mt-10 grid grid-cols-2 gap-4" data-testid="results-grid">
              {RESULTS.map((r, i) => (
                <div key={i} className="card-surface p-6" data-testid={`result-${i}`}>
                  <r.icon size={22} className="text-cyan-400" />
                  <p className="font-display font-black text-4xl md:text-5xl text-white mt-4 glow-text">{r.k}</p>
                  <p className="text-sm text-[#8892B0] mt-2 leading-relaxed">{r.l}</p>
                </div>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="lg:col-span-6"
          >
            <div className="relative rounded-2xl overflow-hidden border border-cyan-400/25">
              <img src={IMAGE} alt="Dashboard" className="w-full aspect-square object-cover" />
              <div className="absolute inset-0 bg-gradient-to-tr from-[#030B1E]/85 via-[#030B1E]/20 to-transparent" />
              <div className="absolute top-6 left-6 right-6">
                <p className="font-mono-tech text-xs text-cyan-400 tracking-widest">// LIVE KPI</p>
                <p className="font-display text-2xl md:text-3xl text-white mt-2 font-bold leading-tight">
                  Do processo manual ao<br />indicador em tempo real.
                </p>
              </div>
              <div className="absolute bottom-6 left-6 right-6 flex gap-4">
                <div className="card-surface flex-1 p-4">
                  <p className="text-xs text-[#8892B0]">Antes</p>
                  <p className="font-display text-2xl text-white mt-1">14 dias</p>
                </div>
                <div className="card-surface flex-1 p-4 border-cyan-400/40">
                  <p className="text-xs text-cyan-400">Depois</p>
                  <p className="font-display text-2xl text-white mt-1">3h</p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
